import { Stack } from 'ui/stack';

import Button from 'components/partials/button/button';
import Modal from 'components/partials/modal/modal';

import MonitoringAlert from 'containers/admin/clients/client/tabs-components/critical-populations/components/monitoring-alert';
import { MONITORING_CONFIRM } from 'containers/admin/clients/client/tabs-components/critical-populations/critical-populations.constants';

interface MonitoringConfirmModalProps {
  onConfirm: () => void;
  onCancel: () => void;
}

const MonitoringConfirmModal = ({
  onConfirm,
  onCancel,
}: MonitoringConfirmModalProps) => {
  const footer = (
    <Stack direction="row" sx={{ alignItems: 'center', gap: 1 }}>
      <Button
        type="button"
        variant="brand-filled"
        size="md"
        onClick={onConfirm}
        data-testid="monitoring-confirm-modal-confirm"
      >
        {MONITORING_CONFIRM.confirmLabel}
      </Button>
      <Button
        type="button"
        variant="neutral-outlined"
        size="md"
        onClick={onCancel}
        data-testid="monitoring-confirm-modal-cancel"
      >
        {MONITORING_CONFIRM.cancelLabel}
      </Button>
    </Stack>
  );

  return (
    <Modal
      headerText={MONITORING_CONFIRM.title}
      onCloseCallback={onCancel}
      showCloseButton
      disableBackdropClick
      skipUnmountOnClose
      footer={footer}
      primaryAction={{ onClick: onConfirm }}
      modalClassName="tablet:w-[640px] p-5 shadow"
      containerClassName="z-[702]"
      backdropClassName="opacity-40"
      headerClassName="text-2xl font-bold"
      data-testid="monitoring-confirm-modal"
    >
      <Stack sx={{ gap: 1.5 }}>
        <p className="text-base text-gray-700">{MONITORING_CONFIRM.body}</p>
        <MonitoringAlert data-testid="monitoring-confirm-modal-note" />
      </Stack>
    </Modal>
  );
};

export default MonitoringConfirmModal;
